import React, { useState } from 'react';
import { EnvelopeSimple, X } from '@phosphor-icons/react';
import { Button } from '../../ui/Button';
interface EmailVerificationBannerProps {
  email?: string;
  onResend?: () => void;
  onDismiss?: () => void;
}
export function EmailVerificationBanner({
  email,
  onResend,
  onDismiss
}: EmailVerificationBannerProps) {
  const [isVisible, setIsVisible] = useState(true);
  const handleDismiss = () => {
    setIsVisible(false);
    onDismiss?.();
  };
  if (!isVisible) return null;
  return <div className="sticky top-0 z-40 w-full bg-lime-4 border-b border-lime-3" data-id="element-1474">
      <div className="max-w-5xl mx-auto px-4 py-3 flex items-start sm:items-center justify-between gap-4" data-id="element-1475">
        <div className="flex items-start sm:items-center gap-3" data-id="element-1476">
          <div className="w-8 h-8 rounded-full bg-lime-3 flex items-center justify-center flex-shrink-0 mt-0.5 sm:mt-0" data-id="element-1477">
            <EnvelopeSimple className="w-4 h-4 text-lime-1" weight="bold" data-id="element-1478" />
          </div>
          <div data-id="element-1479">
            <p className="text-sm font-semibold text-lime-1" data-id="element-1480">
              Contul tău este aproape vizibil pentru proprietari!
            </p>
            <p className="text-xs text-lime-2 mt-0.5" data-id="element-1481">
              Verifică-ți adresa de email {email ? `(${email})` : ''} pentru a
              activa profilul Izio.
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0" data-id="element-1482">
          <Button variant="outline" size="sm" onClick={onResend} className="border-lime-3 text-lime-1 hover:bg-lime-3 h-8 text-xs" data-id="element-1483">
            Retrimite email
          </Button>
          <button onClick={handleDismiss} className="p-1.5 text-lime-3 hover:text-lime-1 rounded-md hover:bg-lime-4 transition-colors" data-id="element-1484">
            <X className="w-4 h-4" data-id="element-1485" />
          </button>
        </div>
      </div>
    </div>;
}